import { render, staticRenderFns } from "./riwayat_kepangkatan.vue?vue&type=template&id=7b1728ea&"
import script from "./riwayat_kepangkatan.vue?vue&type=script&lang=js&"
export * from "./riwayat_kepangkatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports